import { useCallback, useEffect, useState } from 'react'

import { useWorkspaceStore } from '@/stores/workspace.store'

import { currentWebPushState, disableWebPush, enableWebPush, type WebPushState } from './webPush'

/** State and actions for the "browser notifications" control. */
export function useBrowserNotifications() {
  const workspaceId = useWorkspaceStore((s) => s.currentWorkspaceId)
  const [state, setState] = useState<WebPushState>(() => currentWebPushState())
  const [busy, setBusy] = useState(false)

  // The person may change the browser's permission in its settings while the app is open.
  useEffect(() => {
    const refresh = () => setState(currentWebPushState())
    document.addEventListener('visibilitychange', refresh)
    return () => document.removeEventListener('visibilitychange', refresh)
  }, [])

  const enable = useCallback(async () => {
    if (!workspaceId) return
    setBusy(true)
    try {
      setState(await enableWebPush())
    } finally {
      setBusy(false)
    }
  }, [workspaceId])

  const disable = useCallback(async () => {
    if (!workspaceId) return
    setBusy(true)
    try {
      setState(await disableWebPush())
    } finally {
      setBusy(false)
    }
  }, [workspaceId])

  return { state, busy, enable, disable }
}
